<script setup lang="ts">
const modals = useModalStore();
</script>

<template>
  <Modal
    id="UnsupportedBrowserModal"
    :title="$t('SV.LIT_ImproveYourExperience')"
  >
    <p>
      {{ $t("SV.MES_UnsupportedBrowser") }}
    </p>
    <div class="browser-items">
      <a
        class="browser-item"
        href="https://www.google.com/chrome"
        target="_blank"
      >
        <img
          src="https://cdn.ccli.com/songselect/vue/browsers/chrome.svg"
          alt="Google Chrome Logo"
          class="logo"
        />
        <div>{{ $t("SV.LIT_GoogleChrome") }}</div>
      </a>
      <a
        class="browser-item"
        href="https://www.microsoft.com/edge"
        target="_blank"
      >
        <img
          src="https://cdn.ccli.com/songselect/vue/browsers/edge.svg"
          alt="Microsoft Edge Logo"
          class="logo"
        />
        <div>{{ $t("SV.LIT_MicrosoftEdge") }}</div>
      </a>
      <div class="mobile-break" />
      <a
        class="browser-item"
        href="https://www.apple.com/safari/"
        target="_blank"
      >
        <img
          src="https://cdn.ccli.com/songselect/vue/browsers/safari.svg"
          alt="Apple Safari Logo"
          class="logo"
        />
        <div>{{ $t("SV.LIT_AppleSafari") }}</div>
      </a>
      <a
        class="browser-item"
        href="https://www.mozilla.org/en-US/firefox"
        target="_blank"
      >
        <img
          src="https://cdn.ccli.com/songselect/vue/browsers/firefox.svg"
          alt="Mozilla Firefox Logo"
          class="logo"
        />
        <div>{{ $t("SV.LIT_MozillaFirefox") }}</div>
      </a>
    </div>
    <hr />

    <p>
      {{ $t("SV.MES_ContinueWithBrowser") }}
    </p>

    <template #footer>
      <Button
        variant="orange"
        @click.stop.prevent="modals.hideModal()"
        >{{ $t("SV.LIT_IUnderstand") }}</Button
      >
    </template>
  </Modal>
</template>

<style scoped lang="postcss">
.browser-items {
  @apply my-3 flex flex-wrap items-end justify-between gap-2;
}
.browser-item {
  @apply text-center;

  .logo {
    @apply mx-auto h-16 w-16;
  }
}
hr {
  @apply my-5;
}
.mobile-break {
  @apply w-full md:hidden;
}
</style>
